import * as yup from "yup"; 

export const schemaLogin = yup.object().shape({
  email: yup.string().email("El correo debe ser válido").required("El correo es obligatorio"),
  password: yup.string().required("La contraseña es obligatoria"),
});

export const schemaRequest = yup.object().shape({
  institucion_id: yup.string().required("Seleccione una institución"),
  motivo: yup.string().required("Seleccione un motivo"),
});

export const schemaUpdateRequest = (estadoId, cie10Nombre) => {
  return yup.object().shape({
    cie10_id: yup
      .string()
      .when([], {
        is: () => estadoId == 2 && !cie10Nombre,
        then: (schema) => schema.required("Ingrese Código de CIE 10"),
        otherwise: (schema) => schema.optional(),
      }),
    dias: yup
      .string()
      .transform((value) => (value === null ? "" : value)) 
      .when([], {
        is: () => estadoId == 2,
        then: (schema) => schema.required("Ingrese cantidad de días"),
        otherwise: (schema) => schema.optional(),
      }),
  });
};

export const schemaUpdateUser = () => {
  return yup.object().shape({
    name: yup.string().required("El nombre es obligatorio"),
    apellido: yup.string().required("El nombre es obligatorio"),
    email: yup.string().email("Correo inválido").required("El correo es obligatorio"),
    // telefono: yup.string().matches(/^[0-9]+$/, "Solo números"),
  });
  // return yup.object({
  //   name: yup.string().trim().required("El nombre es obligatorio"),
  //   apellido: yup.string().trim().required("El apellido es obligatorio"),
  //   email: yup
  //     .string()
  //     .trim()
  //     .email("Debe ser un email válido")
  //     .required("El email es obligatorio"),
  //   documento: yup.string().trim().required("El documento es obligatorio"),
  //   role_id: yup.number().required("Debe seleccionar un rol"),
  // });
};